import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent {
  myForm: FormGroup;
  signupSuccess = false;
  message: undefined | string;
  city: Array<Location> = [];

  ous: Array<OrganizationUnit> = [];
  filtredOus: Array<OrganizationUnit> = [];
  selectedOus: Array<OrganizationUnit> | any = [];
  selectedOusIds: Array<String> | any = [];

  translator:TranslatorPipe = new TranslatorPipe()

  gender = [{ label: this.translate('male'), test: 'hellow' }, { label: this.translate('feminine') }];

  ngOnInit() {
    this.getCity();
    this.getOUs();
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService
  ) {

    this.myForm = this.formBuilder.group({
      fName: [null, [Validators.required, Validators.minLength(3)]],
      mName: [null, [Validators.required]],
      lName: [null, [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        null,
        [
          Validators.required,
          Validators.pattern(
            '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
          ),
        ],
      ],
      national_id: [
        null,
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
      ],
      gender: [null, [Validators.required]],
      city: [null, [Validators.required]],
    });
  }

  async onSubmit() {
    // handle form submission
    console.log(this.myForm.value);

    const data = this.createLoginObject(this.myForm.value);
    let response = await this.dataService.postData('user/register', data);
    if (response.error == true) {
      this.message = response.msg;
    } else {
      this.signupSuccess = true;
      this.message = response.msg;
    }
  }

  createLoginObject(data: any) {
    return {
      name: {
        first: data.fName,
        middle: data.mName,
        last: data.lName,
      },
      email: data.email.trim(),
      phone: data.phone,
      national_id: data.national_id,
      gender: data.gender.label,
      location: data.city._id,
      active: {
        status: false,
        reason: 'NEW ACCOUNT',
        activationDate: null,
      },
    };
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      console.log('RESPONSE',res)
      if (!res.error) {
        this.city = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  handleOU(id: any) {
    console.log('==>selected OU', this.selectedOus, id);
    this.selectedOusIds.push(id);
    this.selectedOus.push(this.filtredOus.find((ou: any) => ou._id == id));
    this.filtredOus = this.ous.filter((ou) => ou.parent == id);
    // console.log("==>selected OU",this.selectedOus)
  }

  deleteOU(index: any) {
    console.log('==index', index);
    this.selectedOus.splice(index);
    this.selectedOusIds.splice(index);

    if (this.selectedOus.length === 0) {
      this.filtredOus = this.ous.filter((ou) => ou.parent == null);
    } else {
      this.filtredOus = this.ous.filter(
        (ou) => ou.parent == this.selectedOus[this.selectedOus.length - 1]._id
      );
    }
  }

  ouHolder: OrganizationUnit | undefined;

  async getOUs() {
    // try {
    //   let res = await this.dataService.getData('ou');
    //   console.log('RESPONSE',res)
    //   if (!res.error) {
    //     this.ous = res.data;
    //     this.filtredOus = this.ous.filter((ou) => ou.parent == null);
    //     // let y : any = this.filtredOus.find((ou:any)=> ou._id == '643db5fc3e3890db38bb278d')
    //     // this.selectedOus.push(y)                                          // Get OU OF SBC
    //     console.log('ous = >', this.ous, this.selectedOus);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  }

  filterOus(level: any) {
    return this.ous.filter((node) => node.parent === null);
  }
}
